
import { Options, Vue } from 'vue-class-component'
import Employee from '@/employee/Employee'
import Farm from '@/farm/Farm'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import TextButton from '@/components/ui/TextButton.vue'
import util from '@/util'

@Options({
  components: {
    ValueMeter, TextButton
  },
  props: {
    employee: Employee, farm: Farm
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  },
  computed: {
    cssVars() {
      return {
        '--background-image': 'url(' + require('@/assets/wolfgang-hasselmann.jpg') + ')'
      }
    },
    util() {
      return util
    }
  }
})
export default class OfficeTasksCard extends Vue {
  farm!: Farm
}
